import { useCallback, useEffect, useState } from 'react';
import { change } from 'redux-form';
import { useDispatch } from 'react-redux';
import { interval } from './interval';

const use1Second = interval(1e3);

export const useTimer = ({ seconds: initialSeconds = 0, member = null, running: initiallyRunning = false } = {}) => {
    const [seconds, setSeconds] = useState(initialSeconds);

    function zeroPad(num: number, places: number): string {
        const zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join('0') + num;
    }

    const [secondsManually, setSecondsManually] = useState(
        initialSeconds ? zeroPad(Math.floor(initialSeconds / 60), 2) + ':' + zeroPad(initialSeconds % 60, 2) : 0,
    );
    const [running, setRunning] = useState(initiallyRunning);
    const tick = useCallback(() => (running ? setSeconds((seconds) => seconds + 1) : undefined), [running]);
    const dispatch = useDispatch();
    const start = () => {
        setRunning(true);
        setTimeout(() => {
            dispatch(change('program-book', `${member}.answer`, seconds));
        }, 200);
    };
    const pause = () => {
        setRunning(false);
        setTimeout(() => {
            dispatch(change('program-book', `${member}.answer`, seconds));
        }, 200);
    };
    const reset = () => setSeconds(0);
    const stop = () => {
        setRunning(false);
        setSeconds(0);
        setTimeout(() => {
            dispatch(change('program-book', `${member}.answer`, 0));
        }, 200);
    };

    use1Second(tick);

    return { pause, reset, running, seconds, start, stop, setSeconds, setSecondsManually, secondsManually };
};
